<template>
  <div class="contact-page landing-page">
    <div class="landing-page-edit-panel"
         v-if="isGM()">
      <div class="wrapper" :class="[{ 'active': landingPanel }]">
        <div class="landing-page-edit-settings" @click.prevent="landingPanel = !landingPanel"></div>
        <div v-if="editHistory === false">
          <div class="action-btn"
               @click.prevent="pageMetaEdit = true">Edit page meta</div>
          <div class="action-btn"
               v-if="pageEditMode === false"
               @click.prevent="pageEditSwitch()">Edit page content</div>
          <div class="action-btn"
               @click.prevent="activateEditHistory()">Page edit history</div>
        </div>
        <div v-if="editHistory === true">
          <div class="form-group">
            <div class="form-element">
              <label for="page-versions" class="form-label color-2-63">Page save history</label>
              <v-select class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked"
                        :searchable = false
                        @input="changeLandingPage($event)"
                        :options="getPageVersionsForSelect()"
                        data-lpignore="true"
                        id="page-versions" />
            </div>
          </div>
        </div>
        <div class="action-btn-bottom">
          <div class="action-btn action-btn-save"
               v-if="pageEditMode === true"
               @click.prevent="updateLandingPage()">Save</div>
          <div class="action-btn action-btn-discard"
               @click.prevent="discardPageEdit()">Discard</div>
        </div>
      </div>
    </div>
    <div class="wrapper">
      <div class="landing-page-wrapper contact-hero">
        <div class="landing-page-content">
          <div class="landing-page-section">
            <div class="landing-page-hero">
              <h1 class="landing-page-title color-1-100" v-if="!pageEditMode">
                {{ content.heroSection.title }}
              </h1>
              <textarea class="landing-page-title color-1-100"
                        v-if="pageEditMode && isGM()"
                        data-gramm_editor="false"
                        placeholder="Section title"
                        data-lpignore="true"
                        rows="1"
                        v-model="content.heroSection.title"
                        v-on:keydown="autoSize($event)">{{ content.heroSection.title }}</textarea>
              <div class="landing-page-description color-2-77" v-if="!pageEditMode">
                {{ content.heroSection.description }}
              </div>
              <textarea class="landing-page-description color-2-77"
                        v-if="pageEditMode && isGM()"
                        data-gramm_editor="false"
                        placeholder="Section description"
                        data-lpignore="true"
                        rows="1"
                        v-model="content.heroSection.description"
                        v-on:keydown="autoSize($event)">{{ content.heroSection.description }}</textarea>
            </div>
            <div class="landing-page-contact-data">
              <div class="landing-page-contact-data__inner">
                <div class="address">
                  <h2 class="color-1-100">
                    <svg version="1.1" id="icons" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                         viewBox="0 0 12 19.998" style="enable-background:new 0 0 12 19.998;" xml:space="preserve">
                      <g>
                        <path class="st0" d="M6,17.562C8.403,14.679,12,9.737,12,6c0-3.309-2.691-6-6-6S0,2.691,0,6C0,9.738,3.599,14.68,6,17.562z M6,2
                            c2.206,0,4,1.794,4,4c0,2.507-2.438,6.294-4.001,8.382C4.437,12.296,2,8.51,2,6C2,3.794,3.794,2,6,2z"/>
                        <circle class="st0" cx="6" cy="6" r="2"/>
                        <rect x="2" y="17.998" class="st0" width="8" height="2"/>
                      </g>
                    </svg>
                    Address
                  </h2>
                  <span class="contact-info color-2-77" v-if="!pageEditMode">
                    {{ content.contactsSection.address }}
                  </span>
                  <textarea class="contact-info color-2-77"
                            v-if="pageEditMode && isGM()"
                            data-gramm_editor="false"
                            placeholder="Address"
                            data-lpignore="true"
                            rows="1"
                            v-model="content.contactsSection.address"
                            v-on:keydown="autoSize($event)">{{ content.contactsSection.address }}</textarea>
                </div>
                <div class="contacts">
                  <div class="email">
                    <h2 class="color-1-100">
                      <svg version="1.1" id="icons" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                           viewBox="0 0 20 13" style="enable-background:new 0 0 20 13;" xml:space="preserve">
                        <path class="st0" d="M18,0H2C0.897,0,0,0.898,0,2v9c0,1.102,0.897,2,2,2h16c1.103,0,2-0.898,2-2V2C20,0.898,19.103,0,18,0z
                           M16.113,2L10,5.821L3.887,2H16.113z M2,11V3.179l7.47,4.669C9.632,7.949,9.816,8,10,8s0.368-0.051,0.53-0.152L18,3.179L18.001,11H2
                          z"/>
                      </svg>
                      Email
                    </h2>
                    <span class="contact-info color-2-77" v-if="!pageEditMode">
                      {{ content.contactsSection.email }}
                    </span>
                    <textarea class="contact-info color-2-77"
                              v-if="pageEditMode && isGM()"
                              data-gramm_editor="false"
                              placeholder="Email"
                              data-lpignore="true"
                              rows="1"
                              v-model="content.contactsSection.email"
                              v-on:keydown="autoSize($event)">{{ content.contactsSection.email }}</textarea>
                  </div>
                  <div class="phone">
                    <h2 class="color-1-100">
                      <svg version="1.1" id="icons" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                           viewBox="0 0 19 19" style="enable-background:new 0 0 19 19;" xml:space="preserve">
                        <path class="st0" d="M17,11h-4c-1.077,0-1.958,0.855-1.998,1.922c-2.543-0.404-4.473-2.341-4.909-4.925C7.152,7.95,8,7.073,8,6V2
                          c0-1.103-0.897-2-2-2H2C0.897,0,0,0.897,0,2v5c0,6.617,5.383,12,12,12h5c1.103,0,2-0.897,2-2v-4C19,11.897,18.103,11,17,11z M12,17
                          C6.486,17,2,12.515,2,7V2h4v4H5C4.732,6,4.475,6.107,4.287,6.298C4.099,6.49,3.996,6.748,4,7.016C4.072,11.567,7.512,15,12,15
                          c0.552,0,1-0.448,1-1v-1h4l0.001,4H12z"/>
                      </svg>
                      Telephone
                    </h2>
                    <span class="contact-info color-2-77" v-if="!pageEditMode">
                      {{ content.contactsSection.phone }}
                    </span>
                    <textarea class="contact-info color-2-77"
                              v-if="pageEditMode && isGM()"
                              data-gramm_editor="false"
                              placeholder="Telephone"
                              data-lpignore="true"
                              rows="1"
                              v-model="content.contactsSection.phone"
                              v-on:keydown="autoSize($event)">{{ content.contactsSection.phone }}</textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="landing-page-wrapper contact-summary">
        <div class="landing-page-content">
          <div class="landing-page-section">
            <div class="landing-page-summary">
              <h2 class="landing-page-summary__title background-1-10-before color-1-100" v-if="!pageEditMode">
                {{ content.formSection.title }}
              </h2>
              <textarea class="landing-page-summary__title color-1-100"
                        v-if="pageEditMode && isGM()"
                        data-gramm_editor="false"
                        placeholder="Section title"
                        data-lpignore="true"
                        rows="1"
                        v-model="content.formSection.title"
                        v-on:keydown="autoSize($event)">{{ content.formSection.title }}</textarea>
            </div>
            <div class="landing-page-contact-form">
              <template v-if="!formStatus.success">
                <div class="contact-form-group required"
                     :class="[{ 'active': formData.name.text !== '' || formData.name.focus, 'has-error': this.errors.has('Name') }]">
                  <label for="name">Name</label>
                  <input class="contact-form-input"
                         :class="[{ 'border-1-50': formData.name.text !== '' || formData.name.focus }]"
                         v-validate="'required'"
                         id="name"
                         @focus="formData.name.focus = true"
                         @blur="formData.name.focus = false"
                         v-model="formData.name.text"
                         name="Name"
                         type="text">
                </div>
                <div class="contact-form-group required"
                     :class="[{ 'active': formData.surname.text !== '' || formData.surname.focus, 'has-error': this.errors.has('Surname') }]">
                  <label for="surname">Surname</label>
                  <input class="contact-form-input"
                         :class="[{ 'border-1-50': formData.surname.text !== '' || formData.surname.focus }]"
                         v-validate="'required'"
                         id="surname"
                         @focus="formData.surname.focus = true"
                         @blur="formData.surname.focus = false"
                         v-model="formData.surname.text"
                         name="Surname"
                         type="text">
                </div>
                <div class="contact-form-group required"
                     :class="[{ 'active': formData.email.text !== '' || formData.email.focus, 'has-error': this.errors.has('Email') }]">
                  <label for="email">Email</label>
                  <input class="contact-form-input"
                         :class="[{ 'border-1-50': formData.email.text !== '' || formData.email.focus }]"
                         v-validate="'required|email'"
                         id="email"
                         @focus="formData.email.focus = true"
                         @blur="formData.email.focus = false"
                         v-model="formData.email.text"
                         name="Email"
                         type="text">
                </div>
                <div class="contact-form-group required"
                     :class="[{ 'active': formData.phone.text !== '' || formData.phone.focus, 'has-error': this.errors.has('Telephone') }]">
                  <label for="phone">Telephone</label>
                  <input class="contact-form-input"
                         :class="[{ 'border-1-50': formData.phone.text !== '' || formData.phone.focus }]"
                         v-validate="'required'"
                         id="phone"
                         @focus="formData.phone.focus = true"
                         @blur="formData.phone.focus = false"
                         v-model="formData.phone.text"
                         name="Telephone"
                         type="text">
                </div>
                <div class="contact-form-group required"
                     :class="[{ 'active': formData.company.text !== '' || formData.company.focus, 'has-error': this.errors.has('Company') }]">
                  <label for="company">Company name</label>
                  <input class="contact-form-input"
                         :class="[{ 'border-1-50': formData.company.text !== '' || formData.company.focus }]"
                         v-validate="'required'"
                         id="company"
                         @focus="formData.company.focus = true"
                         @blur="formData.company.focus = false"
                         v-model="formData.company.text"
                         name="Company"
                         type="text">
                </div>
                <div class="contact-form-group"
                     :class="[{ 'active': formData.industry.text !== '' || formData.industry.focus, 'has-error': this.errors.has('Industry') }]">
                  <label for="industry">Industry</label>
                  <input class="contact-form-input"
                         :class="[{ 'border-1-50': formData.industry.text !== '' || formData.industry.focus }]"
                         id="industry"
                         @focus="formData.industry.focus = true"
                         @blur="formData.industry.focus = false"
                         v-model="formData.industry.text"
                         name="Industry"
                         type="text">
                </div>
                <div class="contact-form-group"
                     :class="[{ 'active': formData.employees.text !== '' || formData.employees.focus }]">
                  <label for="employees">Approximate number of employees</label>
                  <input class="contact-form-input"
                         :class="[{ 'border-1-50': formData.employees.text !== '' || formData.employees.focus }]"
                         id="employees"
                         @focus="formData.employees.focus = true"
                         @blur="formData.employees.focus = false"
                         v-model="formData.employees.text"
                         name="Employees"
                         type="text">
                </div>
                <div class="contact-form-group textarea"
                     :class="[{ 'active': formData.message.text !== '' || formData.message.focus }]">
                  <label for="message">Message</label>
                  <textarea class="contact-form-textarea"
                            :class="[{ 'border-1-50': formData.message.text !== '' || formData.message.focus }]"
                            id="message"
                            @focus="formData.message.focus = true"
                            @blur="formData.message.focus = false"
                            v-model="formData.message.text"
                            name="Message">{{ formData.message.text }}</textarea>
                </div>
                <div class="contact-form-info">
                  <p aria-hidden="true">Fields marked with * are mandatory.</p>
                  <p>
                    <strong>Privacy:</strong> Your details will be used to keep you informed about resources provided by The Clear Company.
                    <router-link :to="{ name: 'privacy-policy' }">Click here</router-link> to find out more about the services we provide.
                  </p>
                </div>
                <div class="contact-form-actions">
                  <div class="subscribe">
                    <input type="checkbox"
                           aria-hidden="true"
                           tabindex="-1"
                           id="subscribe"
                           v-model="formData.subscribe" />
                    <label for="subscribe" tabindex="0">Subscribe me to the newsletter</label>
                  </div>
                  <a href="#" @click.prevent="submitContactForm()" class="submit background-1-20 background-1-60-hover">Submit message</a>
                </div>
                <div class="contact-form-message"
                     aria-live="assertive"
                     :class="!formStatus.success || this.errors.items ? 'error' : 'success' ">
                  <div v-if="this.formStatus.submitting" class="visually-hidden">
                    Submitting
                  </div>
                  <template v-else>
                    <template v-if="this.errors.items && this.errors.items.length">
                      <h2>Something went wrong.</h2>
                      <ul>
                        <li v-for="error of this.errors.items" >
                          {{ error.msg }}
                        </li>
                      </ul>
                    </template>
                    <template v-if="formStatus.shown">
                      <h2 v-if="formStatus.title !== ''">{{ formStatus.title }}</h2>
                      <p v-if="formStatus.body !== ''">{{ formStatus.body }}</p>
                    </template>
                  </template>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="landing-page-change-image" v-if="pageMetaEdit && isGM()">
      <div class="modal-inner" ref="metaEditPopup">
        <h2>Change page meta</h2>
        <a href="#" class="modal-close" @click.prevent="closePopup()"></a>
        <div class="popup-footer-edit">
          <div>
            <div class="meta-description">
              <label for="meta-title">Title</label>
              <input id="meta-title"
                     placeholder="Page meta title"
                     v-model="metaData.title" />
            </div>
            <div class="meta-description">
              <label for="meta-description">Description</label>
              <textarea id="meta-description"
                        placeholder="Page meta description"
                        v-model="metaData.description">{{ metaData.description }}</textarea>
            </div>
          </div>
        </div>
        <div class="popup-actions">
          <a href="#" @click.prevent="closePopup()" class="discard">Discard</a>
          <a href="#" @click.prevent="updateMeta()" class="submit">Save</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import api from '@/api'

export default {
  name: 'contact',
  data () {
    return {
      pageEditMode: false,
      landingPanel: false,
      pageMetaEdit: false,
      editHistory: false,
      pageVersions: [],
      formStatus: {
        shown: false,
        success: false,
        title: '',
        body: '',
        submitting: false
      },
      metaData: {
        title: '',
        description: ''
      },
      content: {
        title: '',
        description: '',
        heroSection: {
          title: '',
          description: ''
        },
        contactsSection: {
          address: '',
          email: '',
          phone: ''
        },
        formSection: {
          title: ''
        }
      },
      initialContent: {
        heroSection: {
          title: '',
          description: ''
        },
        contactsSection: {
          address: '',
          email: '',
          phone: ''
        },
        formSection: {
          title: ''
        }
      },
      formData: {
        name: {
          text: '',
          focus: false
        },
        surname: {
          text: '',
          focus: false
        },
        email: {
          text: '',
          focus: false
        },
        phone: {
          text: '',
          focus: false
        },
        company: {
          text: '',
          focus: false
        },
        industry: {
          text: '',
          focus: false
        },
        employees: {
          text: '',
          focus: false
        },
        message: {
          text: '',
          focus: false
        },
        subscribe: false
      },
      contactRequest: {
        shown: false,
        success: true,
        message: '',
        email: ''
      },
      windowWidth: window.innerWidth,
      serverValidation: {
        errors: []
      },
      disableAPI: false
    }
  },
  computed: {
    ...mapGetters([
      'getIsLoggedIn',
      'getUserRole',
      'selectedHightCont',
      'getSelectedFontSize'
    ])
  },
  methods: {
    ...mapActions([
      'redirect',
      'getRoles',
      'setFontSizeActive',
      'setColorPaletteActive'
    ]),
    submitContactForm () {
      let self = this
      if (this.disableAPI) return
      this.formStatus.submitting = true
      this.$validator.validateAll().then((valid) => {
        if (!valid) {
          this.formStatus.submitting = false
          return
        }
        if (this.formData.name.text === '' ||
          this.formData.surname.text === '' ||
          this.formData.email.text === '' ||
          this.formData.phone.text === '' ||
          this.formData.company.text === '') {
          return
        }
        let body = {
          name: this.formData.name.text,
          surname: this.formData.surname.text,
          email: this.formData.email.text,
          phone: this.formData.phone.text,
          company: this.formData.company.text,
          industry: this.formData.industry.text,
          employees: this.formData.employees.text,
          message: this.formData.message.text,
          subscribe: this.formData.subscribe
        }
        this.disableAPI = true
        this.$http.post(api.URLS.contactSubmit, body, api.headersAuthSettings).then((res) => {
          this.disableAPI = false
          this.formData.name.text = ''
          this.formData.surname.text = ''
          this.formData.email.text = ''
          this.formData.phone.text = ''
          this.formData.company.text = ''
          this.formData.industry.text = ''
          this.formData.employees.text = ''
          this.formData.message.text = ''
          this.formData.subscribe = false
          this.formStatus.shown = true
          this.formStatus.success = true
          this.formStatus.title = 'Your message was successfully sent.'
          this.formStatus.body = 'We will get in touch with you as soon as possible.'
          setTimeout(function () {
            self.errors.clear()
          }, 100)
          this.formStatus.submitting = false
        }).catch((err) => {
          this.formStatus.submitting = false
          this.serverValidation.errors = err
          this.disableAPI = false
          this.formStatus.shown = true
          this.formStatus.success = false
          this.formStatus.title = 'Something went wrong.'
          this.formStatus.body = 'The message was not send. Please try again or send us your message by email here: support.team@clearassured.co.uk'
        })
      })
    },
    updateLandingPage () {
      if (this.disableAPI) return
      let body = JSON.stringify(this.content)
      let pageData = {
        slug: 'contact-page',
        body: body
      }
      this.disableAPI = true
      this.$http.post(api.URLS.staticpage, pageData, api.headersAuthSettings).then((res) => {
        this.disableAPI = false
        this.getLandingPage()
      }).catch((err) => {
        this.disableAPI = false
        console.log('err', err)
      })
    },
    updateMeta () {
      if (this.disableAPI) return
      let metaTitle = this.metaData.title
      let metaDescription = this.metaData.description
      let pageData = {
        title: metaTitle,
        slug: 'contact-page',
        description: metaDescription
      }
      this.disableAPI = true
      this.$http.post(api.URLS.staticpage, pageData, api.headersAuthSettings).then((res) => {
        this.disableAPI = false
        document.location.reload()
      }).catch((err) => {
        this.disableAPI = false
        console.log('err', err)
      })
    },
    getLandingPage (id) {
      if (this.disableAPI) return
      this.disableAPI = true
      let body = {
        slug: 'contact-page'
      }
      if (id) {
        body.id = id
      }
      this.$http.post(api.URLS.staticpage + '/contact-page', body, api.headersAuthSettings).then((res) => {
        this.disableAPI = false
        let pageData = JSON.parse(res.data.body)
        this.content = pageData
        this.metaData.title = res.data.title
        this.metaData.description = res.data.description
        if (this.metaData.title && this.metaData.title !== '') {
          document.title = this.metaData.title + ' | Clear Assured'
        }
        this.addPageMeta('description', [{name: 'content', value: this.metaData.description}])
        this.content.title = this.metaData.title
        this.content.description = this.metaData.description
        if (id) {
          this.pageEditSwitch()
        } else {
          this.pageEditMode = false
        }
        if (window.ga) {
          window.ga('set', 'contentGroup1', this.$router.currentRoute.name.includes('edit') ? 'ADMINISTRATION_AREA' : 'PUBLIC_PAGE')
          window.ga('send', 'pageview', {
            'page': location.pathname,
            'location': location.href,
            'title': document.title
          })
        }
      }).catch((err) => {
        this.disableAPI = false
        console.log('err', err)
      })
    },
    getPageVersions () {
      let self = this
      if (this.disableAPI) return
      this.disableAPI = true
      this.$http.get(api.URLS.staticpagechanges + '/contact-page', api.headersAuthSettings).then((res) => {
        this.disableAPI = false
        this.pageVersions = []
        for (let index in res.body) {
          self.pageVersions.push({
            label: self.convertDateTime(res.body[index].createdAt),
            id: res.body[index].id
          })
        }
        this.editHistory = true
      }).catch((err) => {
        this.disableAPI = false
        console.log('err', err)
      })
    },
    activateEditHistory () {
      this.getPageVersions()
    },
    getPageVersionsForSelect () {
      return this.pageVersions
    },
    changeLandingPage (el) {
      this.getLandingPage(el.id)
    },
    convertDateTime (payload) {
      if (!payload) return
      let date = new Date(payload)
      let fullYear = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hours = date.getHours()
      let minutes = date.getMinutes()
      let ampm = hours >= 12 ? 'PM' : 'AM'
      let newHours = hours % 12 ? hours % 12 : 12
      function toDoubleDigit (num) {
        return num.toString().length < 2 ? '0' + num : num.toString()
      }
      let dateString = toDoubleDigit(day) + '/' + toDoubleDigit(month) + '/' + fullYear
      let timeString = toDoubleDigit(newHours) + ':' + toDoubleDigit(minutes) + ' ' + ampm
      return dateString + ' ' + timeString
    },
    addPageMeta (name, data) {
      let meta = document.createElement('meta')
      meta.name = name
      for (let index in data) {
        meta.setAttribute(data[index].name, data[index].value)
      }
      document.getElementsByTagName('head')[0].appendChild(meta)
    },
    discardChanges () {
      this.getLandingPage()
    },
    pageEditSwitch () {
      this.pageEditMode = true
      this.$nextTick(() => {
        this.autoSizeOnInit()
      })
    },
    discardPageEdit () {
      this.discardChanges()
      if (this.editHistory) {
        this.editHistory = false
      } else {
        this.landingPanel = false
      }
    },
    autoSize (el) {
      setTimeout(function () {
        el.target.style = 'height:auto; padding:0'
        el.target.style = 'height:' + el.target.scrollHeight + 'px'
      }, 0)
    },
    autoSizeOnInit () {
      let textAreas = document.getElementsByTagName('textarea')
      for (let i = 0; i < textAreas.length; i++) {
        let item = textAreas[i]
        setTimeout(function () {
          item.style = 'height:auto; padding:0'
          item.style = 'height:' + item.scrollHeight + 'px'
        }, 0)
      }
    },
    isGM () {
      let isLogged = this.getIsLoggedIn
      if (!isLogged) {
        return false
      }
      let userRole = this.getUserRole
      if (userRole === 'gm') {
        return true
      }
      return false
    },
    handleWindowResize (event) {
      this.windowWidth = event.currentTarget.innerWidth
    },
    getDeviceType (check) {
      let width = this.windowWidth
      let deviceName = ''
      if (width > 940) {
        deviceName = 'desktop'
      } else if (width > 640) {
        deviceName = 'tablet'
      } else {
        deviceName = 'mobile'
      }
      return check === deviceName
    },
    closePopup () {
      this.pageMetaEdit = false
    }
  },
  created () {
    this.getLandingPage()
  },
  mounted () {
    this.setFontSizeActive()
    this.setColorPaletteActive()
    window.addEventListener('resize', this.handleWindowResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleWindowResize)
  },
  watch: {}
}
</script>

<style src="@/assets/scss/main/landing-page.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// Contact.vue?f369f2bc